<template>
  <CommonChip class="chip" :class="chipClassName" :dark="value === 0">
    <!-- TODO: remove '|| value' when we are sure that only proper marketingValues exist -->
    {{ marketingLabels[value] || value }}
  </CommonChip>
</template>

<script lang="ts">
import Vue from 'vue';

import { marketingLabels } from '@/bundles/Common/types/marketing';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'MarketingPushChip',

  components: { CommonChip },

  props: {
    value: {
      type: Number,
      required: true,
    }
  },

  computed: {
    chipClassName (): string {
      // TODO: remove this condition when we are sure that only proper marketingValues exist
      if (this.value < 0) {
        return 'grey';
      }

      switch (this.value) {
        case 0: return 'red';
        case 1: return 'green lighten-3';
        case 2: return 'green white--text';
        default: return 'green darken-4 white--text';
      }
    },
    marketingLabels (): string[] {
      return marketingLabels;
    }
  }
});
</script>

<style lang="scss" scoped>
  .chip {
    min-width: 75px;
    justify-content: center;
  }
</style>
